import { GetterTree } from 'vuex'
import { RootState } from '@/store'
import { TriggeredReferralState } from '@/store/triggeredReferrals/index'

export const getters: GetterTree<TriggeredReferralState, RootState> = {
    requestParams(state: TriggeredReferralState): any {
        const params = {
            pagination: true,
            page: state.page,
            itemsPerPage: state.itemsPerPage,
            active: state.activeFilter,
            company: state.companyFilter,
            name: state.nameFilter,
        }

        if (state.orderField && state.orderDirection) {
            params[`order[${state.orderField}]`] = state.orderDirection
        }

        return params
    },
}
